import { render } from "./introducePage.vue?vue&type=template&id=2881a881"
import script from "./introducePage.vue?vue&type=script&lang=js"
export * from "./introducePage.vue?vue&type=script&lang=js"

import "./introducePage.vue?vue&type=style&index=0&id=2881a881&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__